<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>

<div *ngIf="!showSpinner">
  <app-menu></app-menu>
  <mat-card>
    <mat-card-title>Entregas</mat-card-title>

    <mat-card-content>

      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let entrega of entregas"
          (opened)="entrega.entregue"
          (closed)="!entrega.entregue">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <b>{{entrega.titulo}}</b>
            </mat-panel-title>
            <mat-panel-description>
              Entrega realizada em: {{entrega.dataHoraEntrega | date:"dd/MM/yyyy" }} as {{entrega.dataHoraEntrega | date:'shortTime'}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p><b>Prazo de entrega: {{entrega.dataHoraLimiteEntrega | date:"dd/MM/yyyy" }} até as {{entrega.dataHoraLimiteEntrega | date:'shortTime'}} </b></p>
          <p><b>Descrição:</b> {{entrega.descricao}}</p>

          <angular-editor [placeholder]="'Digite o conteúdo da entrega ou cole aqui o link da entrega'" [(ngModel)]="entrega.conteudo"></angular-editor>

          <button mat-raised-button (click)="entregar(entrega)">Salvar Entrega: {{entrega.titulo}}</button>
          <div *ngIf="dentroDoPrazo(entrega) || entrega.entregue">
            <p>Entrega realizada em: {{entrega.dataHoraEntrega | date:"dd/MM/yyyy" }} as {{entrega.dataHoraEntrega | date:'shortTime'}} </p>
            <p *ngIf="entrega.atrasado">Status da entrega: Atrasada, cuidado equipe, entregas atrasadas recebem menos pontos!!</p>
            <p *ngIf="!entrega.atrasado">Status da entrega: Dentro do prazo, Parabéns Equipe!!</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

    </mat-card-content>
  </mat-card>
</div>
